'use client';

import { useLayoutEffect } from 'react';

export default function RouteScrollReset() {
  useLayoutEffect(() => {
    const reset = () =>
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    reset();
    const frame = window.requestAnimationFrame(() => {
      reset();
      document.documentElement.classList.remove('is-guide-route-transition');
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);

  return null;
}
